import React from 'react';
import config from "@/config"

function ClassicModeLink() {
    let url = config.APP_STAGE_LEGACY_URL;
    if (url.indexOf("http") === -1) {
        url = "https://" + url;
    }

    return (
        <div className="text-xs">
            <a
                onClick={
                    (e) => {
                        e.preventDefault();
                        sessionStorage.removeItem('user');
                        // @ts-ignore
                        window.location = `${url}/search`;
                    }
                }
                className="text-theme-blue hover:underline"
                href={`${url}/search`}

            >
                (Switch to Legacy Web UI)
            </a>
        </div>
    );
}

export default ClassicModeLink;
